import classNames from 'classnames'
import React from 'react'

interface WalletProps {
	size?: 'sm' | 'md' | 'lg'
	color?: 'brand' | 'gray'
}

const Wallet: React.FC<WalletProps> = ({ size = 'lg', color = 'brand' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="22"
		height="20"
		className={classNames({
			'w-4 h-4': size === 'sm',
			'w-5 h-5': size === 'md',
			'w-[22px] h-[20px]': size === 'lg',
		})}
		fill="none"
		viewBox="0 0 22 20"
	>
		<path
			className={classNames({
				'fill-brand-primary-md': color === 'brand',
				'fill-brand-gray-400': color === 'gray',
			})}
			d="M17.6 4.444h3.3c.292 0 .572.118.778.326.206.208.322.49.322.786v13.333c0 .295-.116.577-.322.786A1.095 1.095 0 0120.9 20H1.1c-.292 0-.572-.117-.778-.325A1.117 1.117 0 010 18.889V1.11C0 .816.116.534.322.325.528.117.808 0 1.1 0h16.5v4.444zM2.2 6.667v11.11h17.6V6.668H2.2zm0-4.445v2.222h13.2V2.222H2.2zm12.1 8.89h3.3v2.221h-3.3v-2.222z"
		/>
	</svg>
)

export default Wallet
